
(function () {
  "use strict";

  var root = document.querySelector(".secret-sale-page--beta-b");
  if (!root) return;

  // Google Apps Script endpoint
  var GOOGLE_SHEETS_URL =
    "https://script.google.com/macros/s/AKfycby7DmSS-t3TjGmcFXQFwDlv9TnnWBa-Q_MUj6-nBynZaDgIbnNSMMoQphrcCMXyZiwWgg/exec";

  // Countdown to VIP Sale
  var START = new Date("2026-10-31T08:00:00+01:00").getTime();
  var boxes = root.querySelectorAll("#cd b");

  function tick() {
    var d = Math.max(0, START - Date.now());

    [
      Math.floor(d / 86400000),
      Math.floor(d / 3600000) % 24,
      Math.floor(d / 60000) % 60,
      Math.floor(d / 1000) % 60
    ].forEach(function (value, index) {
      if (boxes[index]) {
        boxes[index].textContent = String(value).padStart(2, "0");
      }
    });
  }

  tick();
  window.setInterval(tick, 1000);

  // Log registration to Google Sheets.
  // This does not replace or call Klaviyo.
  function saveRegistration(email, submissionId) {
    var payload = new URLSearchParams({
      email: email,
      page_url: window.location.href,
      submission_id: submissionId
    });

    return fetch(GOOGLE_SHEETS_URL, {
      method: "POST",
      mode: "no-cors",
      body: payload,
      keepalive: true
    }).catch(function (error) {
      console.error("[VIP Sale] Google Sheets logging failed:", error);
    });
  }

  // Signup forms: supports both forms on the page.
  root.querySelectorAll("[data-secret-sale-form]").forEach(function (form) {
    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      var msg = form.querySelector("[data-form-message]");
      var button = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      );

      var key = root.getAttribute("data-klaviyo-key");
      var listId = root.getAttribute("data-klaviyo-list");

      var emailInput = form.querySelector('input[type="email"]');
      var consentInput = form.querySelector(
        'input[name="email_consent"], input[type="checkbox"]'
      );

      var email = emailInput
        ? (emailInput.value || "").trim().toLowerCase()
        : "";

      function showMessage(text, type) {
        if (!msg) return;

        msg.className = "ss-form-message";
        if (type) msg.classList.add("is-" + type);
        msg.textContent = text;
      }

      // Validate email and marketing consent.
      if (
        !email ||
        !emailInput ||
        !emailInput.checkValidity() ||
        !consentInput ||
        !consentInput.checked
      ) {
        showMessage(
          "Bitte geben Sie eine gültige E-Mail-Adresse ein und stimmen Sie dem E-Mail-Marketing zu.",
          "error"
        );

        if (emailInput && (!email || !emailInput.checkValidity())) {
          emailInput.focus();
        } else if (consentInput && !consentInput.checked) {
          consentInput.focus();
        }

        return;
      }

      // Validate Klaviyo configuration.
      if (!key || !listId || key === "XXXXXX") {
        showMessage(
          "Die Anmeldung ist noch nicht konfiguriert. Bitte versuchen Sie es später erneut.",
          "error"
        );
        return;
      }

      if (button) {
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
      }

      showMessage("Ihre Anmeldung wird verarbeitet …");

      // One unique ID for this form submission.
      var submissionId =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : "reg-" + Date.now() + "-" +
            Math.random().toString(36).slice(2, 12);

      // Start logging the submitted registration.
      // Await the request before redirecting, but don't block Klaviyo
      // if the Google logging request fails.
      var loggingPromise = saveRegistration(email, submissionId);

      var payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source:
              "Thomsen Secret Sale landing page - Variant B",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  properties: {
                    secret_sale_variant: "B",
                    secret_sale_campaign: "2026"
                  },
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: "SUBSCRIBED"
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      };

      try {
        var response = await fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=" +
            encodeURIComponent(key),
          {
            method: "POST",
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2026-07-15"
            },
            body: JSON.stringify(payload)
          }
        );

        if (response.ok || response.status === 202) {
          // Give the independent logging request time to complete
          // before navigating away.
          await loggingPromise;

          if (window.fbq) {
            window.fbq("track", "Lead", {
              content_name: "Secret Sale",
              variant: "B"
            });
          }

          try {
            window.dispatchEvent(
              new CustomEvent("secret_sale_signup_success", {
                detail: { variant: "B" }
              })
            );
          } catch (_) {}

          window.location.assign(
            "/pages/secret-sale-bestaetigung"
          );
          return;
        }

        var errorText = await response.text();
        var detail = "";

        console.error(
          "[VIP Variant B] Klaviyo subscription failed:",
          response.status,
          errorText
        );

        try {
          var errorData = JSON.parse(errorText);

          detail =
            errorData.errors &&
            errorData.errors[0] &&
            errorData.errors[0].detail
              ? errorData.errors[0].detail
              : "";
        } catch (_) {}

        showMessage(
          "Die Anmeldung konnte nicht abgeschlossen werden. " +
            (detail || "Bitte versuchen Sie es erneut."),
          "error"
        );

      } catch (error) {
        console.error(
          "[VIP Variant B] Form submission failed:",
          error
        );

        showMessage(
          "Verbindungsfehler. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
          "error"
        );

      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute("aria-busy");
        }
      }
    });
  });

  // Floating action button visibility
  var fab = root.querySelector("#fab");

  if (fab) {
    var seen = new Set();

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              seen.add(entry.target);
            } else {
              seen.delete(entry.target);
            }
          });

          fab.classList.toggle("on", seen.size === 0);
        },
        { threshold: 0.15 }
      );

      root
        .querySelectorAll(".kv, .vf, .midbox, .reg2")
        .forEach(function (element) {
          observer.observe(element);
        });
    } else {
      fab.classList.add("on");
    }
  }
})();
